import { Component, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { GetService } from "./dataservice/get.service";
import { environment } from "../environments/environment";
import { LanguageService } from './dataservice/language.service';
declare var require;

//var createGuest = require('cross-domain-storage/guest')
import { Observable, Subject } from "rxjs";
let loginshare = new Subject<any>();
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  timer = 0;

  modalRef: BsModalRef;
  title = "web-share";

  is_login = "";

  // bazStorage = createGuest('http://localhost:4200');

  constructor(public mls: LanguageService,
    private modalService: BsModalService,
    private getservice: GetService
  ) {


    if (localStorage.getItem("token") != null) {
      loginshare.next("1");
      //window.location.href="https://app.docquity.com";
    } else {
      loginshare.next("1");
      // not login
    }

    loginshare.subscribe((data) => {
      // console.log(data)
      this.is_login = data;
      this.getservice.is_login = this.is_login;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  ngOnInit() { }
}
